import 'jquery-validation';
import {showButtonLoader, hideButtonLoader} from '../../util/helpers';

export default {
  init: function () {

    var notificationsForm = $('#accountForm');
    var submitButton = $('#wp-submit');

    submitButton.on('click', function (e) {
      e.preventDefault();
      showButtonLoader(submitButton);
      
      setTimeout(() => {
        var valid = notificationsForm.valid();
        if (valid) {
          setTimeout(function () {
            notificationsForm.submit();
          }, 1000);
        }else {
          hideButtonLoader(submitButton);
        }
      }, 1000);
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/account/notifications.js